<!-- use Playground.vue to play around with the gantt chart components and test out new features -->
<template>
  <div class="mes-plan header-padding" v-loading="loading">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="status" :groups="radios" type="arrow" @change="selectCase" />
        </span>
      </div>

      <div class="toolbox">
        <el-button
          :type="isSave != 3 ? 'default' : 'success'"
          :disabled="isSave != 3"
          @click="savePlan"
        >
          <i class="iconfont icon-save" role="button"></i>
          <span class="ml-xs">保存排产</span>
        </el-button>
        <el-button
          :type="
            !(isSave != 3 && willPublish.length != 0) ? 'default' : 'success'
          "
          :disabled="!(isSave != 3 && willPublish.length != 0)"
          @click="sendTask"
        >
          <i class="iconfont icon-issue" role="button"></i>
          <span class="ml-xs">下发任务</span>
        </el-button>
      </div>
    </div>
    <div class="big-contain">
      <div class="table-headder flex">
        <div style="width: 160px" class="font-16">工位看板</div>
        <div>
          <span class="font-16">生产任务</span>
          <span class="ml text-muted">
            待排产
            <div class="block-color bg-lightpurple"></div>
          </span>
          <span class="ml text-muted">
            待下发
            <div class="block-color bg-purple"></div>
          </span>
          <span class="ml text-muted">
            待开工
            <div class="block-color bg-blue"></div>
          </span>
          <span class="ml text-muted">
            待完工
            <div class="block-color bg-primary"></div>
          </span>
        </div>
        <div class="item-width ml-sm">
          <mes-num-selector
            v-model="mfgid"
            size="mini"
            placeholder="选择制号"
            @change="selectMf(mfgid)"
          />
        </div>
        <div class="item-width ml-sm">
          <el-autocomplete
            v-model="keyword"
            value-key="workorder_no"
            prefix-icon="el-icon-search"
            size="mini"
            :fetch-suggestions="querySearch"
            clearable
            placeholder="搜索工单"
            @select="searchG"
            @change="clearLight"
          >
            <template slot-scope="{ item }">
              <div>{{ item.workorder_no }}</div>
            </template>
          </el-autocomplete>
        </div>
        <el-radio-group v-model="radio" class="ml-sm" size="mini" @change="changeDate">
          <el-radio-button :label="1">时</el-radio-button>
          <el-radio-button :label="2">日</el-radio-button>
          <el-radio-button :label="4">周</el-radio-button>
          <el-radio-button :label="15">月</el-radio-button>
        </el-radio-group>
        <div class="flex align-items-center show-willlist" role="button" @click="toggleMenu()">
          <el-button v-if="showMenu" class="ml font-16" type="text">待排产任务</el-button>
          <el-button v-else class="ml font-16" type="text">展开</el-button>
          <el-tooltip :content="!showMenu ? '展开菜单' : '隐藏菜单'" placement="bottom">
            <div class="flex-center font-lg text-lighter" style="color: #07c160">
              <i v-if="!showMenu" class="el-icon-s-fold" />
              <i v-else class="el-icon-s-unfold" />
            </div>
          </el-tooltip>
        </div>
      </div>
      <g-gantt-chart
        :chart-start="chartStart"
        :chart-end="chartEnd"
        :grid="grid"
        :hide-timeaxis="hideTimeaxis"
        :push-on-overlap="false"
        snap-back-on-overlap
        :row-label-width="`${rowLabelWidth}%`"
        :row-height="rowHeight"
        :intert="interTime"
        :theme="'vue'"
        :bar-container="barContainer"
        @dragend-bar="onDragend($event)"
        @drop="show"
        @changeaxis="changeAxis"
      >
        <template slot="pp-head-left">
          <pp-station-selector
            v-model="stationid"
            placeholder="选择工位"
            @change="ppselecter(stationid)"
          />
        </template>
        <template>
          <g-gantt-row
            v-for="(row, index) in rowsList"
            :key="`ganttastic_row_${index}`"
            :label="row.label"
            :bars="row.barList"
            :dragid="dragid"
            :row="row"
            :rowN="index"
            :rowcount="rowsList.length"
            @drop="drop"
            :highlight-on-hover="highlightOnHover"
            @barContainer="getBarContainer"
            @closePopover="closePopover"
            @update="fetchData"
            :activeid="activeid"
            bar-start="plan_starttime"
            bar-end="plan_endtime"
          >
            <template slot="label">
              <div v-if="row.id" class="flex" style="width: 100%">
                <div class="bd ellipsis">{{ row.label }}</div>
                <div v-if="row.equipid && row.is_maintain" class="ft text-danger">维护中</div>
                <div v-if="!row.equipid" class="ft text-danger font-sm">未关联设备</div>
              </div>
              <div v-else @click="toPpStation" role="button">{{ row.label }}</div>
            </template>
          </g-gantt-row>
        </template>
      </g-gantt-chart>

      <div v-if="showMenu" class="will-plan" v-loading="ploading">
        <el-select v-model="keyWill" filterable placeholder="选择工单" clearable @change="searchWill">
          <el-option
            v-for="item in willList"
            :key="item.workorderid"
            :label="item.workorder_no"
            :value="item.workorderid"
          ></el-option>
        </el-select>
        <div class="flex justify-content-space-between mt-sm mb-sm">
          <el-badge :value="to_plan" :max="99" class="item">
            <el-button icon="el-icon-upload2" type="success" plain @click="importShow = true">导入</el-button>
          </el-badge>
          <el-button icon="el-icon-delete" :disabled="!currentWillList.length" @click="clearPlan">清空</el-button>
        </div>
        <div v-if="currentWillList.length == 0" class="empty">
          <div class="flex-center" style="height: 400px">
            <el-button
              v-if="willList"
              @click="importShow = true"
              type="primary"
              size="small"
              style="width: 100px"
            >导入</el-button>
          </div>
        </div>
        <virtual-list
          v-else-if="showList"
          class="w-plan-box"
          :list-data="currentWillList"
          height="100%"
          :estimated-item-size="30"
          :topLoadMore="true"
          v-slot="slotProps"
        >
          <div class="w-gantt-plan mb-xs">
            <el-popover placement="left-start" width="400" trigger="hover">
              <div class="pl pr text-black">
                <div class="pull-right font-16">{{ slotProps.item.station_title }}</div>
                <div class="text-muted flex">
                  {{ slotProps.item.label }}
                  <el-tooltip content="主工单" placement="top" v-if="slotProps.item.type == 1" >
                    <icon-svg icon-class="maintask" style="font-size: 22px"/>
                  </el-tooltip>
                  <el-tooltip content="子工单" placement="top" v-else-if="slotProps.item.type == 2">
                    <icon-svg icon-class="subtask" style="font-size: 22px"/>
                  </el-tooltip>
                </div>

                <div class="font-20">{{ slotProps.item.process_title }}</div>
                <div class="pt pb process">
                  <div class="flex justify-content-space-between font-12">
                    <span v-if="slotProps.item.status <= 20" class="text-muted">计划开工</span>

                    <span v-if="slotProps.item.status < 80" class="text-muted">计划完工</span>
                  </div>
                  <el-progress
                    v-if="slotProps.item.status <= 20"
                    :percentage="0"
                    :show-text="false"
                    color="#409EFF"
                  ></el-progress>
                </div>
                <div class="pb pt">
                  <div class="pt-sm flex" v-if="slotProps.item.mfg_no">
                    <div class="d-title">制号</div>：
                    <div></div>
                    {{ slotProps.item.mfg_no }}
                  </div>
                  <div class="pt-sm flex" v-if="slotProps.item.material_no">
                    <div class="d-title">部件</div>：
                    <div></div>
                    {{
                    slotProps.item.material_no +
                    " / " +
                    slotProps.item.material_title
                    }}
                  </div>
                  <div class="pt-sm flex" v-if="slotProps.item.process_no">
                    <div class="d-title">工序</div>：
                    <div></div>
                    {{
                    slotProps.item.process_no +
                    " / " +
                    slotProps.item.process_title
                    }}
                  </div>
                  <div class="pt-sm flex" v-if="slotProps.item.plan_num">
                    <div class="d-title">数量</div>：
                    <div></div>
                    <span class="tag mr-xs font-10">派工</span>
                    {{ slotProps.item.plan_num }} 件
                  </div>
                  <div class="pt-sm flex" v-if="slotProps.item.standard_hour">
                    <div class="d-title">工时</div>：
                    <div></div>
                    <span class="tag mr-xs font-10">派工</span>
                    {{
                    slotProps.item.standard_hour +
                    slotProps.item.standard_unit +
                    " /件"
                    }}
                    <span
                      class="tag ml-xs mr-xs font-10"
                      v-if="slotProps.item.add_hour"
                    >附加</span>
                    <span v-if="slotProps.item.add_hour">
                      {{
                      slotProps.item.add_hour +
                      " " +
                      slotProps.item.standard_unit
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                slot="reference"
                :id="slotProps.item.id"
                :style="willStyle"
                :draggable="true"
                @dragstart.stop="dragstart($event)"
              >{{ slotProps.item.label }}</div>
            </el-popover>
            <div class="hover-show">
              <i
                class="el-icon-close"
                role="button"
                @click.stop="removePlan(slotProps.item.workorderid)"
              ></i>
            </div>
          </div>
        </virtual-list>
        <div
          v-if="willList.length"
          class="pt-sm pb-sm text-center bottom-tip"
          style="background-color: #fff"
        >已导入{{ willList.length }}条</div>
      </div>
    </div>
    <mes-import v-if="importShow" :show.sync="importShow" @submit="handleImport" />
  </div>
</template>

<script>
import {
  allPlanApi,
  planListApi,
  postPlanApi,
  statMesApi,
  removeMesApi,
  removeAllMesApi
} from "@/api/mes/planApi";
import { getStationDataApi } from "@/api/pp/stationApi";
import { sendMesWorkorderApi } from "@/api/mes/workorderApi";
import { array2Object, second2String, parseTime } from "@/utils/common";
import moment from "moment";
import Vue from "vue";
moment.locale("zh-cn");

export default {
  name: "MesPlan",
  components: {
    GGanttChart: () => import("./components/GGanttChart.vue"),
    GGanttRow: () => import("./components/GGanttRow.vue"),
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
    PpStationSelector: () => import("@/views/pp/components/PpStationSelector"),
    VirtualList: () => import("./components/VirtualList.vue"),
    MesImport: () => import("./components/MesImport.vue")
  },

  data() {
    return {
      importShow: false,
      showList: true,
      cont: 0,
      radio: 4,
      keyword: "",
      keyWill: "",
      isSave: 0,
      status: 0,
      mfgid: null,
      activeid: null,
      showMenu: 1,
      interTime: 4,
      pickRange: [],
      chartStart: moment(new Date())
        .subtract(0, "days")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm"),
      chartEnd: moment(new Date())
        .add(7, "days")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm"),
      pushOnOverlap: true,
      grid: true,
      rowHeight: 40,
      stationid: null,
      stationidWill: null,
      willList: [],
      currentWillList: [],
      to_plan: 0,
      radios: [
        { value: 0, title: "全部进度", separate: true },
        { value: 1, title: "待排产" },
        { value: 2, title: "待下发" },
        { value: 3, title: "已下发" }
      ],
      rowLabelWidth: 10,
      hideTimeaxis: false,
      highlightOnHover: false,
      event: null,
      rowsList: [],
      dragid: null,
      loading: false,
      ploading: false,
      barContainer: new DOMRect(),
      initDate: new Date(),
      lightArr: [],
      searchItem: [],
      options: [],
      hasPushed: []
    };
  },
  computed: {
    willStyle() {
      return {
        top: null
      };
    },
    duration() {
      let start = moment(this.chartStart);
      let end = moment(this.chartEnd);
      return end.diff(start, "h");
    },
    willPublish() {
      let tmp = [];
      this.rowsList.forEach(value => {
        value.barList.forEach(v => {
          if (v.status == 10) {
            tmp.push(v.workorderid);
          }
        });
      });
      return tmp;
    }
  },
  watch: {
    currentWillList() {
      this.showList = false;
      this.$nextTick(() => {
        this.showList = true;
      });
    }
  },
  beforeCreate() {},
  created() {
    if (window.localStorage.getItem("showMenu") != null) {
      this.showMenu = parseInt(localStorage.getItem("showMenu"));
    }
    this.fetchData();
    this.changeDate();
  },

  beforeRouteLeave(to, from, next) {
    if (this.isSave > 2) {
      this.$confirm(`排产信息已更新，是否保存？`, "保存排产", {
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(async () => {
          let x = await this.savePlan();
          if (!x.errno) {
            next();
          } else {
            next(false);
          }
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  },

  mounted() {
    var _this = this;
    window.onbeforeunload = function(e) {
      if (_this.$route.fullPath == "/mes/plan" && _this.isSave > 2) {
        e = e || window.event;
        if (e) {
          e.returnValue = "排产信息已更新，是否继续重新加载?";
        }
        return "排产信息已更新，是否继续重新加载?";
      } else {
        window.onbeforeunload = null;
      }
    };
  },

  methods: {
    async fetchData() {
      this.isSave = 0;
      this.loading = true;
      this.fetchPlanList();
      //数据格式处理
      let stationData = await getStationDataApi();
      if (!stationData.errno && stationData.data.length) {
        stationData.data.forEach((item, index) => {
          item["id"] = "row" + (index + 1);
          item["row"] = index + 1;
          item["label"] = item.station_title;
          item["barList"] = [];
          item["rowConfig"] = { display: true };
        });
        this.rowsList = stationData.data;
        let xt = array2Object(stationData.data, "stationid");
        let planlist = await planListApi();
        if (!planlist.errno && planlist.data.length) {
          const nowtime = parseInt(new Date().getTime() / 1000);
          this.options = Object.assign([], planlist.data);
          planlist.data.forEach(ite => {
            if (xt[String(ite.stationid)]) {
              if (ite.status == 30) {
                ite.total_used =
                  nowtime - ite.starttime < 60
                    ? "0min"
                    : second2String(nowtime - ite.starttime, false, true);
                ite["percentage"] =
                  ((nowtime - ite.starttime) /
                    (ite.plan_endtime - ite.plan_starttime)) *
                    100 <
                  100
                    ? ((nowtime - ite.starttime) /
                        (ite.plan_endtime - ite.plan_starttime)) *
                      100
                    : 100;
                if (ite.status == 30 && ite.percentage >= 100)
                  ite.percentage = 95;
              }
              ite.plan_endtime = parseTime(
                ite.plan_endtime,
                "{y}-{m}-{d} {h}:{i}"
              );
              ite.plan_starttime = parseTime(
                ite.plan_starttime,
                "{y}-{m}-{d} {h}:{i}"
              );
              ite["label"] = ite.workorder_no;
              ite["id"] = ite.workorderid;
              ite["row"] = xt[String(ite.stationid)].row;
              if (ite.status == 10) {
                Vue.set(ite, "ganttBarConfig", {
                  color: "white",
                  background: "#997bec",
                  handles: true,
                  pushOnOverlap: false
                });
              } else if (ite.status == 20) {
                Vue.set(ite, "ganttBarConfig", {
                  color: "white",
                  background: "#409eff",
                  handles: true,
                  pushOnOverlap: false
                });
              } else if (ite.status == 30) {
                Vue.set(ite, "ganttBarConfig", {
                  color: "white",
                  background: "#cdf3df",
                  handles: true,
                  pushOnOverlap: false
                });
              } else if (ite.status > 30) {
                Vue.set(ite, "ganttBarConfig", {
                  color: "white",
                  background: "#cdf3df",
                  immobile: true,
                  pushOnOverlap: false
                });
              }
              xt[String(ite.stationid)].barList.push(ite);
            }
          });
          this.rowsList.forEach(item => {
            if (xt[String(item.stationid)]) {
              item = Object.assign({}, xt[String(item.stationid)]);
            }
          });
          // this.rowsList = object2Array(xt)
          this.loading = false;
        } else {
          if (planlist.errno) this.$message.error(planlist.message);
          this.loading = false;
        }
      } else {
        if (!stationData.data.length)
          this.rowsList = [{ label: "暂无数据", id: null, barList: [] }];
        if (stationData.errno) this.$message.error(stationData.message);
        this.loading = false;
      }

      // })
    },

    fetchPlanList() {
      this.ploading = true;
      statMesApi().then(res => {
        if (!res.errno) {
          this.to_plan = res.data.to_plan;
        }
      });
      allPlanApi({ planning: 1 }).then(res => {
        this.ploading = false;
        if (!res.errno) {
          res.data.forEach(item => {
            item["label"] = item.workorder_no;
            item["id"] = item.workorderid;
            item["ganttBarConfig"] = {
              color: "black",
              backgroundColor: "#ccbdf5",
              handles: true
            };
          });
          this.willList = res.data.filter(
            item => !this.hasPushed.includes(item.workorderid)
          );
          this.searchWill(false);
        }
      });
    },

    handleImport() {
      this.keyWill = null;
      this.fetchPlanList();
    },

    clearPlan() {
      this.$confirm(`即将清空已导入的工单，是否继续？`, "提示", {
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        removeAllMesApi().then(res => {
          if (!res.errno) {
            this.$message.success("清空成功！");
            this.fetchData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    removePlan(workorderid) {
      removeMesApi({ workorderid }).then(res => {
        if (!res.errno) {
          this.$message.success("移除成功");
          this.fetchPlanList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    toggleMenu() {
      if (this.showMenu) {
        this.showMenu = 0;
      } else {
        this.showMenu = 1;
      }
      window.localStorage.setItem("showMenu", this.showMenu);
    },

    closePopover(index) {
      this.activeid = index;
    },

    seleByMfgid(it) {
      console.log("[ it,this.mfgid ] >", it, this.mfgid);
      if (this.mfgid) {
        if (it.mfgid == this.mfgid) {
          Vue.set(it.ganttBarConfig, "highlight", true);
        } else {
          Vue.set(it.ganttBarConfig, "highlight", false);
        }
      } else {
        Vue.set(it.ganttBarConfig, "highlight", true);
      }
    },

    selectCase() {
      console.log("[ this.status ] >", this.status);
      switch (this.status) {
        case 1:
          this.rowsList.forEach(item => {
            item.barList.forEach(it => {
              if (it.status != 0) {
                Vue.set(it.ganttBarConfig, "highlight", false);
              } else {
                this.seleByMfgid(it);
              }
            });
          });
          break;
        case 2:
          this.rowsList.forEach(item => {
            item.barList.forEach(it => {
              if (it.status == 10) {
                this.seleByMfgid(it);
              } else {
                Vue.set(it.ganttBarConfig, "highlight", false);
              }
            });
          });
          break;
        case 3:
          this.rowsList.forEach(item => {
            item.barList.forEach(it => {
              if (it.status > 10) {
                this.seleByMfgid(it);
              } else {
                Vue.set(it.ganttBarConfig, "highlight", false);
              }
            });
          });
          break;
        default:
          this.rowsList.forEach(item => {
            item.barList.forEach(it => {
              if (this.mfgid) {
                if (it.mfgid == this.mfgid) {
                  Vue.set(it.ganttBarConfig, "highlight", true);
                  // this.ppselecter(it.stationid)
                } else {
                  Vue.set(it.ganttBarConfig, "highlight", false);
                }
              } else {
                Vue.set(it.ganttBarConfig, "highlight", false);
              }
            });
          });
      }
    },

    changeAxis(arr) {
      this.chartStart = arr[0].format("YYYY-MM-DD HH:mm");
      this.chartEnd = arr[1].format("YYYY-MM-DD HH:mm");
    },

    getBarContainer(b) {
      this.barContainer = b;
    },

    querySearch(queryString, cb) {
      var options = this.options;
      var results =
        queryString || this.mfgid || this.status != 0
          ? options.filter(item => {
              switch (this.status) {
                case 1:
                  return this.mfgid
                    ? item.status === 0 &&
                        item.workorder_no.match(queryString) &&
                        item.mfgid === this.mfgid
                    : item.status === 0 && item.workorder_no.match(queryString);
                case 2:
                  return this.mfgid
                    ? item.status === 10 &&
                        item.workorder_no.match(queryString) &&
                        item.mfgid === this.mfgid
                    : item.status === 10 &&
                        item.workorder_no.match(queryString);
                default:
                  return this.mfgid
                    ? item.status > 10 &&
                        item.workorder_no.match(queryString) &&
                        item.mfgid === this.mfgid
                    : item.status > 10 && item.workorder_no.match(queryString);
              }
            })
          : options;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    //编号搜索
    searchG(its) {
      var duration = this.duration;
      if (its) {
        this.rowsList.forEach((item, i1) => {
          item.barList.forEach((it, i2) => {
            if (it.workorderid == its.workorderid) {
              this.activeid = its.workorderid;
              let hour = moment(it.plan_starttime).hour();
              let mdurtaion = parseInt(duration / 2) + (hour % this.interTime);
              let initTime = moment(it.plan_starttime).startOf("h");
              let start = initTime
                .subtract(mdurtaion, "h")
                .format("YYYY-MM-DD HH:mm");
              let end = moment(start)
                .add(duration, "h")
                .format("YYYY-MM-DD HH:mm");

              Vue.set(it.ganttBarConfig, "highlight", true);
              this.searchItem = [i1, i2];
              this.chartStart = start;
              this.chartEnd = end;
              this.ppselecter(it.stationid);
            } else {
              Vue.set(it.ganttBarConfig, "highlight", false);
            }
          });
        });
      }
      return its.workorder_no;
    },

    clearLight() {
      this.activeid = null;
      this.stationid = null;
      let [i1, i2] = this.searchItem;
      if (!this.keyword) {
        Vue.set(
          this.rowsList[i1].barList[i2].ganttBarConfig,
          "highlight",
          false
        );
        this.selectCase();
      }
    },
    //制号筛选
    selectMf(mfgid) {
      var duration = this.duration;
      var tmp = true;
      if (mfgid) {
        this.rowsList.forEach((item, i1) => {
          item.barList.forEach((it, i2) => {
            if (
              it.mfgid == mfgid &&
              (it.status == this.status || this.status == 0)
            ) {
              if (tmp) {
                let start = moment(it.plan_starttime)
                  .startOf("day")
                  .format("YYYY-MM-DD HH:mm");
                let end = moment(start)
                  .add(duration, "h")
                  .format("YYYY-MM-DD HH:mm");
                Vue.set(it.ganttBarConfig, "highlight", true);
                this.chartStart = start;
                this.chartEnd = end;
                tmp = false;
                this.ppselecter(it.stationid);
              }
              this.lightArr.push([i1, i2]);
            } else {
              Vue.set(it.ganttBarConfig, "highlight", false);
            }
          });
        });
        this.selectCase();
      } else {
        this.lightArr.forEach(item => {
          let [l1, l2] = item;
          Vue.set(
            this.rowsList[l1].barList[l2].ganttBarConfig,
            "highlight",
            false
          );
        });
        this.selectCase();
        this.lightArr = [];
      }
    },

    searchWill() {
      if (this.keyWill) {
        this.currentWillList = [
          this.willList.find(item => item.workorderid == this.keyWill)
        ];
      } else {
        this.currentWillList = Object.assign([], this.willList);
      }
    },
    //修改变动
    onDragend(e) {
      console.log("[ e ] >", e);
      this.activeid = null;
      this.isSave = 3;
      if (e.moveRow != 0) {
        let moves = e.moves;
        var tmp = [];
        if (moves) {
          var newb = [];

          let item = moves.find(m => m.id == e.bar.id);
          console.log("[ item ] >", item);
          let iIndex = item.row - 1;
          let index = this.rowsList[iIndex].barList.findIndex(
            m => item.id == m.id
          );

          tmp = Object.assign([], this.rowsList[iIndex].barList);
          newb = tmp.splice(index, 1);
          item.row = iIndex + e.moveRow + 1;
          newb[0].station_no = this.rowsList[item.row - 1].station_no;
          newb[0].station_title = this.rowsList[item.row - 1].station_title;
          newb[0].stationid = this.rowsList[item.row - 1].stationid;
          let xtmp = Object.assign([], this.rowsList[item.row - 1].barList);
          xtmp.push(newb[0]);
          Vue.set(this.rowsList[iIndex], "barList", []);
          Vue.set(this.rowsList[iIndex], "barList", tmp);
          Vue.set(this.rowsList[item.row - 1], "barList", []);
          Vue.set(this.rowsList[item.row - 1], "barList", xtmp);
        }
      }
    },

    changeDate() {
      this.initDate = moment(
        (moment(this.chartStart).valueOf() + moment(this.chartEnd).valueOf()) /
          2
      ).format("YYYY-MM-DD HH:mm");
      switch (this.radio) {
        case 1:
          this.interTime = 1;
          this.chartStart = moment(this.initDate)
            .subtract(12, "hours")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          this.chartEnd = moment(this.initDate)
            .add(12, "hours")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          break;
        case 2:
          this.interTime = 4;
          this.chartStart = moment(this.initDate)
            .subtract(36, "hours")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          this.chartEnd = moment(this.initDate)
            .add(36, "hours")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          break;

        case 4:
          this.interTime = 12;
          this.chartStart = moment(this.initDate)
            .subtract(3, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          this.chartEnd = moment(this.initDate)
            .add(4, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          break;
        case 15:
          this.interTime = 24;
          this.chartStart = moment(this.initDate)
            .subtract(17, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          this.chartEnd = moment(this.initDate)
            .add(18, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm");
          break;
      }
    },

    show(e) {
      // console.log(e, 'eeeeeeeeeeeeeeeeeeeshow')
    },
    //拖拽目标丢入
    drop(e) {
      this.keyWill = null;
      this.searchWill();
      this.activeid = null;
      this.isSave = 3;
      this.hasPushed.push(this.dragid);
      if (e.event && e.event.toElement.id) {
        let toRow = parseInt(e.event.toElement.id.replace("row", "")) + 1;
        let i = null;
        let result = this.willList.find((item, index) => {
          if (item.id == this.dragid) i = index;
          return item.id == this.dragid;
        });

        if (
          moment(e.time).hour() < 9 ||
          (moment(e.time).hour() > 12 && moment(e.time).hour() < 13)
        ) {
          e.time = moment(e.time).format("YYYY-MM-DD") + " 08:30:00";
        } else if (moment(e.time).hour() > 18) {
          e.time = moment(
            moment(e.time).format("YYYY-MM-DD") + " 08:30:00"
          ).add(1, "days");
        }

        result["plan_starttime"] = moment(e.time).format("YYYY-MM-DD HH:mm:ss");
        let emd = moment(
          this.calEndTime(
            parseInt(new Date(result.plan_starttime).getTime() / 1000),
            result.plan_total_hour
          ) * 1000
        ).format("YYYY-MM-DD HH:mm:ss");
        result["plan_endtime"] = emd;
        result["stationid"] = this.rowsList[toRow - 1].stationid;
        result["station_no"] = this.rowsList[toRow - 1].station_no;
        result["station_title"] = this.rowsList[toRow - 1].station_title;
        result["status"] = 0;
        result.row = toRow;
        let tmp = Object.assign([], this.rowsList[toRow - 1].barList);
        tmp.push(result);
        let rtmp = Object.assign({}, this.rowsList[toRow - 1]);
        rtmp.barList = tmp;
        Vue.set(this.rowsList, toRow - 1, rtmp);

        if (i != null) {
          let tmp = this.willList.splice(i, 1);
          this.options.push(tmp[0]);
        }
      }
    },

    getWeekDays(starttime, endtime) {
      let days = moment(endtime).diff(starttime, "days");
      var count = 0;
      for (let i = 0; i < days; i++) {
        let tmp = moment(starttime)
          .add(i + 1, "days")
          .day();
        if (tmp == 0 || tmp == 6) {
          count++;
        }
      }
      return count;
    },

    calEndTime(starttime, duration) {
      let i = 0;
      let endtime = 0;
      let remain_sec = duration;
      let time_table = [[30600, 43200], [46800, 63000]];
      let start_sec = (starttime + 8 * 3600) % 86400;
      let usable_sec = 0;
      let t = 0;
      do {
        for (let tb of time_table) {
          t = [tb[0] + 86400 * i, tb[1] + 86400 * i];
          if (start_sec < t[1]) {
            usable_sec = t[1] - Math.max(start_sec, t[0]);
            if (usable_sec >= remain_sec) {
              endtime =
                starttime + Math.max(start_sec, t[0]) + remain_sec - start_sec;
              return endtime;
            } else {
              remain_sec -= usable_sec;
            }
          }
        }
        i++;
      } while (1);

      return endtime;
    },
    //计划拖拽
    dragstart(e) {
      this.dragid = parseInt(e.target.id);
    },

    savePlan() {
      return new Promise((resolve, reject) => {
        let newArray = [];
        this.rowsList.forEach(item => {
          item.barList.forEach(it => {
            newArray.push({
              workorderid: it.workorderid,
              plan_starttime: moment(it.plan_starttime)
                .startOf("m")
                .unix(),
              plan_endtime: moment(it.plan_endtime)
                .startOf("m")
                .unix(),
              stationid: item.stationid
            });
          });
        });
        postPlanApi({ plan_info: newArray }).then(res => {
          this.activeid = null;
          if (!res.errno) {
            this.fetchData();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          resolve(res);
        });
      });
    },

    sendTask() {
      sendMesWorkorderApi({ workorderids: this.willPublish }).then(res => {
        if (!res.errno) {
          this.fetchData();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //工位滚动
    ppselecter(id) {
      this.stationid = id;
      this.rowsList.forEach(it => {
        if (id === it.stationid) {
          Vue.set(it, "showSlide", true);
          var row = document.getElementById("row" + it.id);
          row.scrollIntoView(false);
        } else {
          Vue.set(it, "showSlide", false);
        }
      });
    },

    toPpStation() {
      if (this.row.id == null) {
        this.$router.push("/pp/station");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mes-plan {
  position: absolute;
  user-select: none;
  height: 100%;
  width: 100%;

  .big-contain {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: calc(100% - 10px);
    padding: 0px 10px;
    background: white;
    overflow-x: scroll;

    .table-headder {
      align-items: center;
      width: 100%;
      background-color: white;
      padding: 10px;

      .item-width {
        width: 160px;
      }

      .block-color {
        display: inline-block;
        width: 16px;
        height: 8px;
        border-radius: 10px;
      }

      .show-willlist {
        position: absolute;
        right: 10px;
        height: 30px;
        line-height: 30px;
      }
    }

    .will-plan {
      position: absolute;
      background: rgb(248, 249, 252);
      padding: 10px 10px 0;
      margin-left: 30px;
      right: 10px;
      top: 48px;
      height: calc(100% - 60px);
      width: 210px;
      z-index: 99;
      box-shadow: 0 0px 12px 0 rgba(0, 0, 0, 0.1);

      .bottom-tip {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
      }
    }
  }

  .empty {
    margin: 40px auto;
    width: 160px;
    text-align: center;
  }

  .w-plan-box {
    height: calc(100% - 140px);
    overflow-y: auto;
  }

  .w-gantt-plan {
    position: relative;
    align-items: center;
    text-align: center;
    color: rgba(16, 16, 16, 1);
    width: 100%;
    height: 28px;
    line-height: 28px;
    border-radius: 15px;
    background: rgba(153, 123, 236, 0.5);
    overflow: hidden;

    &:hover {
      .hover-show {
        display: flex;
      }
    }

    .hover-show {
      position: absolute;
      justify-content: center;
      align-items: center;
      top: 0;
      right: 10px;
      height: 100%;

      &:hover {
        color: #07c160;
      }
    }
  }
}

.process {
  border-bottom: 1px solid #e0e3ea;
}

.tag {
  color: #997bec;
  padding: 0px 2px;
  border-radius: 2px;
  border: 1px solid #997bec;
}

.d-title {
  min-width: 30px;
}
</style>
